'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _hyphenateStyleName = require('hyphenate-style-name');

var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fallbackValue(style) {
  Object.keys(style).forEach(function (property) {
    var value = style[property];
    if (Array.isArray(value)) {
      style[property] = value.join(';' + (0, _hyphenateStyleName2.default)(property) + ':');
    } else if (value instanceof Object) {
      style[property] = fallbackValue(value);
    }
  });

  return style;
} /*  weak */

exports.default = function () {
  return fallbackValue;
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ../~/fela/lib/plugins/fallbackValue.js
// module id = 470
// module chunks = 0